/**
 * 與 {@link AuthenticationService.isEmbedded} 同義，抽出以避免 RouteState 與 Auth 循環依賴。
 */
export function isLaasPortalEmbeddedInParentFrame(): boolean {
  if (typeof window === 'undefined') {
    return false;
  }
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}
